import { Auth0Context, useAuth0 } from '@auth0/auth0-react'
import {
  Box,
  Button,
  Container,
  Link,
  Stack,
  Typography
} from '@mui/material'
import { isNil } from 'lodash/fp'
import log from 'loglevel'
import { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { Loading } from '../Loading'
import {
  RegistrationStatus,
  FormInputDatas,
  UserOutletContext
} from '../../types'
import { AppEntrySubscription } from '@mzc-watchover/terashite-entry-graphql'
import { ServerError } from '../ServerError'
import { domainName, httpRequest } from '../../functions/common'

// const testMemberId = 'VTER5cc72f27a38e4e71be026a038c4fa0bf'
// const testMemberId = 'DTER5cc72f27a38e4e71be026a038c4fa0bf'
export const ContractInfo = () => {
  const { user } = useAuth0(Auth0Context)
  const { memberId } = useOutletContext<UserOutletContext>()
  const navigate = useNavigate()
  const handleClickEdit = () => {
    navigate('/user/edit')
  }
  const [loading, setLoding] = useState<boolean>(true)
  const [hasError, setHasError] = useState<boolean>(false)
  const [subscription, setSubscription] = useState<
    AppEntrySubscription | undefined
  >(undefined)
  const [entry, setEntry] = useState<FormInputDatas | undefined>(undefined)

  useEffect(() => {
    const loadCustomerData = async () => {
      if (isNil(memberId)) {
        log.error(
          '[CustomerInfo] cannot get customer data'
        )
        setHasError(true)
        return undefined
      }
      const customerData = await httpRequest(
        'get',
        `https://${domainName}/v1/users/${memberId}`,
        undefined,
        { authorization: user?.sub }
      )
      if (isNil(customerData)) {
        log.error(
          '[CustomerInfo] cannot get customer data'
        )
        setHasError(true)
        return undefined
      }
      const { status, data } = customerData
      if (status !== 200) {
        log.error(
          '[CustomerInfo] cannot found customer data'
        )
        setHasError(true)
        return undefined
      }
      const { status: registStatus, subscription, entry } = data
      if (registStatus === RegistrationStatus.subscription) {
        setSubscription(subscription)
      } else {
        setEntry(entry)
      }
      setLoding(false)
    }
    loadCustomerData()
  }, [])

  return (
    <Box>
      {loading ? (
        <Loading />
      ) : hasError ? (
        <ServerError />
      ) : (
        <Container sx={{ pt: 5 }}>
          <Box component="form" sx={{ mt: 1 }}>
            <Stack>
              <Typography
                align="left"
                variant="h4"
                sx={{
                  borderLeft: 20,
                  borderBottom: 1,
                  borderColor: 'orange',
                  paddingLeft: 1
                }}>
                ご契約状況
                <Button
                  size="large"
                  sx={{ ml: 10, mb: 1, bgcolor: 'orange', color: 'white' }}
                  onClick={handleClickEdit}>
                  変更
                </Button>
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  お名前（漢字）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {!isNil(subscription)
                  ? `${subscription.lastName} ${subscription.firstName}`
                  : !isNil(entry)
                  ? `${entry.lastName} ${entry.firstName}`
                  : ''}
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  お名前（かな）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {!isNil(subscription)
                  ? `${subscription.lastNameHiragana} ${subscription.firstNameHiragana}`
                  : !isNil(entry)
                  ? `${entry.lastNameKana} ${entry.firstNameKana}`
                  : ''}
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  郵便番号
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {!isNil(subscription)
                  ? `${subscription.zip}`
                  : !isNil(entry)
                  ? `${entry.postalCode}`
                  : ''}
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  住所
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {!isNil(subscription)
                  ? `${subscription.state}${subscription.city}${subscription.address}`
                  : !isNil(entry)
                  ? `${entry.pref}${entry.city}${entry.town}${entry.place}`
                  : ''}
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電話番号
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {' '}
                {!isNil(subscription)
                  ? `${subscription.phoneNo}`
                  : !isNil(entry)
                  ? `${entry.phone}`
                  : ''}
              </Typography>
              <Typography
                align="left"
                variant="h4"
                sx={{
                  borderLeft: 20,
                  borderBottom: 1,
                  borderColor: 'orange',
                  paddingLeft: 1
                }}>
                TC ID登録情報
                <Typography fontSize={'small'}>
                  （メールアドレス・パスワード）
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                確認・変更は
                <Link href="https://id.chuden.co.jp/" target="_blank">こちら</Link>
              </Typography>
              <Typography
                align="left"
                variant="h4"
                sx={{
                  borderLeft: 20,
                  borderBottom: 1,
                  borderColor: 'orange',
                  paddingLeft: 1
                }}>
                登録クレジットカード
              </Typography>
              <Typography variant="subtitle2">
                確認・変更は
                <Link href="/user/paymentEdit" >こちら</Link>
              </Typography>
              <Typography
                align="left"
                variant="h4"
                sx={{
                  borderLeft: 20,
                  borderBottom: 1,
                  borderColor: 'orange',
                  paddingLeft: 1
                }}>
                見守られる方（ご家族さま）
                <Typography fontSize={'small'}>（変更不可）</Typography>
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電気契約名義
                </Typography>
              </Typography>
              <Typography variant="subtitle2">
                {!isNil(subscription)
                  ? `${subscription.cisName}`
                  : !isNil(entry)
                  ? `${entry?.contractorName}`
                  : ''}
              </Typography>
              <Typography variant="subtitle1">
                <Typography component={'span'} sx={{ ml: 1 }}>
                  電気契約住所
                </Typography>
              </Typography>
              {!isNil(subscription) ? (
                <Typography variant="subtitle2">
                  {subscription.cisAddress}
                </Typography>
              ) : (
                <></>
              )}
            </Stack>
          </Box>
        </Container>
      )}
    </Box>
  )
}
